module.exports = __webpack_public_path__ + "img/guan-new2.9010da3e.png";